import { Translation } from 'cng-common/features/translations'
import { getFormattedFinance } from 'cng-common/helpers/numbers'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../configs/translations'
import { MdfOverviewCard } from '../../../mdfOverviewCard'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.overview.requested

interface IRequestedOverviewCardProps {
  totalRequested: number
  isUsd: boolean
  activeCurrency: string
}

export const RequestedOverviewCard = ({
  totalRequested,
  isUsd,
  activeCurrency,
}: IRequestedOverviewCardProps) => (
  <MdfOverviewCard
    title={KEYS.title}
    replaceParams={[{ key: '{currency}', value: activeCurrency }]}
    value={getFormattedFinance(totalRequested, {
      withCurrencySign: isUsd,
      maximumFractionDigits: 0,
    })}
    footer={<Translation text={KEYS.footerTitle} />}
  />
)

RequestedOverviewCard.displayName = 'RequestedOverviewCard'
